import { useTranslation } from 'react-i18next';
import { Modal } from './Modal';
import { Button } from './Button';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  /** Corps du message ; texte simple ou contenu riche. */
  message?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Style destructif (bouton rouge). */
  danger?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirmation standard de l'application — remplace les window.confirm()
 * natifs pour un rendu et un comportement homogènes (focus trap, Échap,
 * bouton danger pour les actions destructives).
 */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onCancel} disabled={loading}>
            {cancelLabel ?? t('common.cancel')}
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmLabel ?? t('common.confirm')}
          </Button>
        </>
      }
    >
      {message ? (
        typeof message === 'string' ? (
          <p className="text-[13px] leading-relaxed text-muted">{message}</p>
        ) : (
          message
        )
      ) : null}
    </Modal>
  );
}
